import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, Search as SearchIcon } from "lucide-react";
import { api } from "@/lib/api";
import { fdatetime } from "@/lib/format";
import { EmptyState, Loader, PageTitle } from "@/components/common";
import { MemberRow } from "@/pages/member/Network";

export function Notifications() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/notifications").then(({ data: d }) => {
      setData(d);
      if (d.unread) api.post("/notifications/read-all");
    }).catch(() => setData({ items: [] }));
  }, []);
  return (
    <div className="mr-fade-up">
      <PageTitle eyebrow="Notifications" title="Vos notifications" />
      {data === null ? <Loader /> : data.items.length === 0 ? (
        <EmptyState icon={Bell} title="Aucune notification" text="Rappels de cotisation, messages et nouvelles des opérations s'afficheront ici." testId="notifications-empty" />
      ) : (
        <ul className="space-y-2">
          {data.items.map((n) => (
            <li key={n.id}>
              <Link to={n.link || "#"} data-testid="notification-row" className={`mr-card block p-4 ${n.read_at ? "" : "border-l-2 border-l-mr-accent"}`}>
                <p className="font-medium text-[15px]">{n.title}</p>
                {n.body && <p className="text-sm text-mr-text2 mt-1">{n.body}</p>}
                <p className="text-xs text-mr-muted mt-2 tabular">{fdatetime(n.created_at)}</p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function Search() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  useEffect(() => {
    if (q.trim().length < 2) return setRes(null);
    const t = setTimeout(() => api.get("/search", { params: { q } }).then(({ data }) => setRes(data)).catch(() => {}), 300);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="mr-fade-up">
      <PageTitle eyebrow="Recherche" title="Rechercher" />
      <div className="relative mb-5">
        <SearchIcon size={17} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-mr-muted" />
        <input data-testid="search-input" autoFocus className="mr-input pl-10" placeholder="Un membre, une entreprise, un produit…" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      {res && (res.members.length === 0 ? (
        <EmptyState icon={SearchIcon} title="Aucun résultat" text="Essayez avec un autre mot." testId="search-empty" />
      ) : (
        <div className="space-y-2" data-testid="search-results">{res.members.map((m) => <MemberRow key={m.id} m={m} />)}</div>
      ))}
    </div>
  );
}
